export default __webpack_public_path__ + "static/NelsonO-7b2a9c23f81ad88eb8734a0cf57683e2.png";